import {getErrorTranslationKeys} from '@/domain/useCases/exceptionHandling';

export const getDoRequest = (
  setPendingRequest: (isLoading: boolean) => void,
  setRequestSucceeded: (succeded: boolean) => void,
  setRequestError: (error?: Array<string>) => void,
) => {
  return <T, >(
    func: () => Promise<T>,
    callbacks?: {
      thenDo?: (result: T) => void,
      catchDo?: (error: unknown) => void,
      finallyDo?: () => void,
    }
  ) => {
    setPendingRequest(true);
    func()
      .then(x => {
        setRequestSucceeded(true);
        setRequestError(undefined);
        if (callbacks?.thenDo) callbacks?.thenDo(x);
      })
      .catch(exception => {
        setRequestSucceeded(false);
        setRequestError(getErrorTranslationKeys(exception));
        if (callbacks?.catchDo) callbacks?.catchDo(exception);
      })
      .finally(() => {
        setPendingRequest(false);
        if (callbacks?.finallyDo) callbacks?.finallyDo();
      });
  };
};
